'use strict';

/**
 * LoopsMarkdownEditor — the same rich markdown editor (pict-section-markdowneditor) the Docs Lake and
 * the entity-form descriptions use, dedicated to the Drafting Kit loops editor. It mounts into
 * #dk-loops-mdhost and is seeded from AppData.LoopsMarkdownEditor.Segments with the loops rendered as a
 * markdown checklist (see source/LoopMarkdown.js); the settings view reads its content on save and
 * parses it back to the structured loop trees. A separate instance from the field editor so the two
 * never fight over the same host element / data address.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-LoopsMarkdownEditor';
	tmpConfig.DefaultDestinationAddress = '#dk-loops-mdhost';
	tmpConfig.TargetElementAddress = '#dk-loops-mdhost';
	tmpConfig.ContentDataAddress = 'AppData.LoopsMarkdownEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'off';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#dk-loops-mdhost';
		}
	}

	return tmpConfig;
}

// A per-loop instance config: one editor per loop key (design / build / feedback), each bound to its own
// host element and data address, so the three never share state and no `## heading` parsing is needed.
function configForLoop(pKey)
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-LoopEditor-' + pKey;
	tmpConfig.DefaultDestinationAddress = '#dk-loop-mdhost-' + pKey;
	tmpConfig.TargetElementAddress = '#dk-loop-mdhost-' + pKey;
	tmpConfig.ContentDataAddress = 'AppData.LoopEditor_' + pKey + '.Segments';
	tmpConfig.DefaultPreviewMode = 'off';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#dk-loop-mdhost-' + pKey;
		}
	}

	return tmpConfig;
}

class PictViewLoopsMarkdownEditor extends libMarkdownEditor
{
}

module.exports = PictViewLoopsMarkdownEditor;
module.exports.default_configuration = buildConfiguration();
module.exports.configForLoop = configForLoop;
